import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ServiceResponse } from '@sdbn/common';
import { AppServerAPI } from '@sdbn/common';
import { DeleteTransport } from '../model/out/delete-transport';

@Injectable({
  providedIn: 'root'
})
export class DeleteTransportService {

  constructor(private appServerAPI: AppServerAPI) { }

  deleteTransport(deleteTransport: DeleteTransport): Observable<ServiceResponse> {
    return this.appServerAPI.execute('/client/control/transport/delete', deleteTransport);
  }

}
